<template>
  <div>
    <div class="flex-col h-32 border-b-2 border-gray-200 my-auto w-screen md:w-full">
      <div class="m-auto h-full flex w-11/12 mx-auto">
        <div class="flex w-1/4">
          <img :src="image"
            style="height: 6rem; width: 6rem"
            class="w-full m-auto rounded"/>
        </div>
        <div class="flex-col my-auto w-3/4">
          <div class="font-bold text-3xl">
            {{ name }}
          </div>
          <div class="text-md">
            {{ address }}
          </div>
        </div>
      </div>
    </div>
    <div class="flex h-16 border-b-2 border-gray-200 w-11/12 mx-auto">
      <div class="flex-col m-auto flex-1">
        <div class="font-light text-md md:text-lg">
          Phone Number:
        </div>
        <div class="font-black text-xs md:text-sm">
          {{instructor_phone_number}}
        </div>
      </div>
      <div class="flex-col m-auto flex-1">
        <div class="font-light text-md md:text-lg">
          Rating:
        </div>
        <div class="flex">
          <svg v-for="i in 5" :key="i" viewBox="0 0 24 24" :class="i <= instructor_rating ? 'text-green-500' : 'text-gray-400'" class="h-6 w-6 fill-current">
            <path d="M8.128 19.825a1.586 1.586 0 0 1-1.643-.117 1.543 1.543 0 0 1-.53-.662 1.515 1.515 0 0 1-.096-.837l.736-4.247-3.13-3a1.514 1.514 0 0 1-.39-1.569c.09-.271.254-.513.475-.698.22-.185.49-.306.776-.35L8.66 7.73l1.925-3.862c.128-.26.328-.48.577-.633a1.584 1.584 0 0 1 1.662 0c.25.153.45.373.577.633l1.925 3.847 4.334.615c.29.042.562.162.785.348.224.186.39.43.48.704a1.514 1.514 0 0 1-.404 1.58l-3.13 3 .736 4.247c.047.282.014.572-.096.837-.111.265-.294.494-.53.662a1.582 1.582 0 0 1-1.643.117l-3.865-2-3.865 2z" />
          </svg>
        </div>
      </div>
      <div class="flex-col m-auto flex-1">
        <div class="font-light text-md md:text-lg">
          Website:
        </div>
        <div class="font-black text-xs md:text-sm text-green-500">
          <a v-if="website" :href="`${website}?ref=strumm`" class="hover:underline">
            Link
          </a>
          <p v-else>No Website Listed</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'InstructorProfileHeader',
  props: {
    name: {
      type: String,
      default: ''
    },
    image: {
      type: String,
      default: ''
    },
    address: {
      type: String,
      default: ''
    },
    formatted_phone_number: {
      type: String,
      default: ''
    },
    rating: {
      type: Number,
      default: null
    },
    website: {
      type: String,
      default: ''
    }
  },
  computed: {
    instructor_phone_number () {
      return this.formatted_phone_number ? this.formatted_phone_number : 'No Number Listed'
    },
    instructor_rating () {
      return this.rating ? this.rating : 'No Ratings'
    }
  }
}
</script>
